import { boolean, number, object, string } from '@gogame/schemas';

import { scopeSchema as conceptFamiliesScopeSchema } from 'scenes/Gallery/GalleryPage/ConceptFamilies/schemas';
import { scopeSchema as conceptsScopeSchema } from 'scenes/Gallery/GalleryPage/Concepts/schemas';
import { scopeSchema as creativesScopeSchema } from 'scenes/Gallery/GalleryPage/Creatives/schemas';
import {
  SCOPE_CREATIVES,
  SCOPE_CONCEPTS,
  SCOPE_CONCEPT_FAMILIES,
  SEARCH_BY_ID_NAME_TAG,
} from 'scenes/Gallery/GalleryPage/constants';

import { filtersSchema } from './filtersSchema';

export const screenSchema = object({
  filters: filtersSchema,
  presetId: number(),
  searchQuery: string(),
  searchType: number().default(SEARCH_BY_ID_NAME_TAG),
  ready: boolean().default(true),
  [SCOPE_CREATIVES]: creativesScopeSchema,
  [SCOPE_CONCEPTS]: conceptsScopeSchema,
  [SCOPE_CONCEPT_FAMILIES]: conceptFamiliesScopeSchema,
});

export const mapPresetToState = (presetData) =>
  screenSchema.cast(presetData || {}, { parseConst: true, context: {} });
